window.initEChartsLoader = initEChartsLoader;

function initEChartsLoader() {
    var echartElement = document.getElementById('echart-loader');
    
    if (echartElement && typeof echarts !== 'undefined') {
        try {
            var myChart = echarts.init(echartElement);
            var option = {
                graphic: {
                    elements: [
                        {
                            type: 'group',
                            left: 'center',
                            top: 'center',
                            children: new Array(7).fill(0).map((val, i) => ({
                                type: 'rect',
                                x: i * 12,
                                shape: { x: 0, y: -35, width: 8, height: 35 },
                                style: { 
                                    fill: i % 2 === 0 ? '#000000ff' : '#313131ff', 
                                },
                                keyframeAnimation: {
                                    duration: 1800,
                                    delay: i * 200,
                                    loop: true,
                                    keyframes: [
                                        { percent: 0, scaleY: 0.1, easing: 'cubicOut' },
                                        { percent: 0.3, scaleY: 1, easing: 'cubicInOut' },
                                        { percent: 0.7, scaleY: 0.3, easing: 'cubicInOut' },
                                        { percent: 1, scaleY: 0.1, easing: 'cubicIn' }
                                    ]
                                }
                            }))
                        }
                    ]
                }
            };

            myChart.setOption(option);
            return true;
        } catch (error) {
            console.warn('ECharts loader failed:', error);
            return false;
        }
    }
    return false;
}
 
document.addEventListener("DOMContentLoaded", function() { 
    const echartsLoaded = initEChartsLoader();
     
    if (!echartsLoaded) {
        console.warn('ECharts loader not available, page will load normally');
    }
 
    setTimeout(function() {
        const loader = document.getElementById('loader');
        if (loader) {
            loader.classList.add('fade-out');
             
            setTimeout(function() { 
                const echartElement = document.getElementById('echart-loader');
                if (echartElement && typeof echarts !== 'undefined') {
                    const chartInstance = echarts.getInstanceByDom(echartElement);
                    if (chartInstance) {
                        chartInstance.dispose();
                    }
                }
            }, 800);  
        }
    }, 1100);
});
 
function loadPageContent(url) {
    var loaderElement = document.getElementById("loader");
    if (loaderElement) {
        loaderElement.style.display = "flex";
         
        initEChartsLoader();
        
        setTimeout(function() {
            loaderElement.classList.add('fade-out');
        }, 1100);
    }
}